import React from 'react'
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio
} from '@material-ui/core'
import { useField } from 'react-final-form'

const DocumentValidator = ({
  legend = 'O documento está legível?',
  ...props
}) => {
  const field = useField(props.name)
  const fieldValue =
    field.input.value !== ''
      ? field.input.value === true || field.input.value === 'sim'
        ? 'sim'
        : 'nao'
      : null

  const handleChange = (e, value) => {
    field.input.onChange(e, value)
    props.onChange && props.onChange(e, value)
  }

  return (
    <FormControl component="fieldset" disabled={props.disabled}>
      <FormLabel component="legend">{legend}</FormLabel>
      <RadioGroup
        row
        {...field}
        {...props}
        onChange={handleChange}
        value={fieldValue}
      >
        <FormControlLabel value="sim" control={<Radio />} label="Sim" />
        <FormControlLabel value="nao" control={<Radio />} label="Não" />
      </RadioGroup>
    </FormControl>
  )
}

export default DocumentValidator
